"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeToUsernameAuth = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const changeToUsernameAuth = exports.changeToUsernameAuth = (0, _actionGenerator.actionGenerator)(_types.EStateActionTypes.ChangeStateToUsernameAuth);